<template>
    <div class="buttonList" :class="[align, 'step' + step]">
      <Ubutton v-for="item in data" :key="item.index" :size="size" :text="item.name" :state="item.state" :icon="item.icon" :iconSize="item.iconSize" :iconStyle="item.iconStyle" :lineSize="item.lineSize" :lineStyle="item.lineStyle" @click.native="item.click(item.param)">
        <span v-if="item.slot" v-html="item.slot"/>
      </Ubutton>
    </div>
</template>

<script>
export default {
  props: {
    data: { type: Array },
    size: { type: String, default: 'small' },
    align: { type: String, default: 'left' },
    step: { type: Number }
  },
  name: 'UbuttonList',
  methods: {
  }
}
</script>

<style scoped>
.buttonList {
  display: flex;
}
.buttonList.left {
  margin-right: auto;
}
.buttonList.left button {
  margin-right: 5px;
}
.buttonList.center {
  margin: 0 auto;
}
.buttonList.center button {
  margin-right: 5px;
}
.buttonList.right {
  margin-left: auto;
}
.buttonList.right button {
  margin-left: 5px;
}
.buttonList.popup {
  margin: 0 auto;
  width: 100%;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
}
.buttonList.step5 > div:nth-child(1n+1) {
  margin-left: 5px;
}
.buttonList.step10 > div:nth-child(1n+1) {
  margin-left: 10px;
}
.buttonList.step15 > div:nth-child(1n+1) {
  margin-left: 15px;
}
.buttonList.step20 > div:nth-child(1n+1) {
  margin-left: 20px;
}
.buttonList .ubutton span + span {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/UbuttonList.vue